/**
 * Navigation visual themes from Figma (ICM Pre-Login A 2026):
 * - `blue`  → "Blue BG" frames (navy shell, white text, peach active)
 * - `white` → "White BG" frames (white shell, ink text, orange active)
 */
export type NavTheme = "blue" | "white";

export const DEFAULT_NAV_THEME: NavTheme = "blue";

export type NavThemeStyles = {
    shell: string;
    link: string;
    linkActive: string;
    search: string;
    mega: string;
    megaItem: string;
    megaSectionTitle: string;
    viewport: string;
    mobileShell: string;
    mobileItem: string;
    secondaryCta: string;
};

export const navThemeStyles: Record<NavTheme, NavThemeStyles> = {
    blue: {
        shell: "bg-nav-bg text-nav-text",
        link: "text-nav-text",
        // Figma: colors/shades/sunrise-orange/200
        linkActive: "font-bold text-[#FBCBAD]",
        search: "text-nav-text",
        mega: "bg-nav-bg text-nav-text",
        megaItem:
            "text-nav-text hover:bg-nav-fg hover:font-bold focus:bg-nav-fg focus:font-bold",
        megaSectionTitle: "text-nav-text",
        viewport: "bg-nav-bg text-nav-text",
        mobileShell: "bg-nav-bg text-nav-text",
        mobileItem: "text-nav-text hover:bg-nav-fg",
        // Solid white CTA on navy (no outline needed)
        secondaryCta:
            "bg-cta-secondary text-cta-secondary-text hover:bg-cta-secondary-hover hover:text-cta-secondary-text-hover",
    },
    white: {
        shell: "bg-white text-ink-header",
        link: "text-ink-header",
        // Figma: colors/brand-colors/sunrise-orange
        linkActive: "font-bold text-brandAccent",
        search: "text-cta-primary",
        mega: "bg-white text-ink-body",
        megaItem:
            "text-ink-body hover:bg-cta-secondary-hover hover:font-bold focus:bg-cta-secondary-hover focus:font-bold",
        megaSectionTitle: "text-ink-header",
        viewport: "bg-white text-ink-body",
        mobileShell: "bg-white text-ink-header",
        mobileItem: "text-ink-header hover:bg-cta-secondary-hover",
        // Outlined secondary on white bar
        secondaryCta:
            "border border-cta-secondary-stroke bg-cta-secondary text-cta-secondary-text hover:bg-cta-secondary-hover hover:text-cta-secondary-text-hover",
    },
};
